import { render, staticRenderFns } from "./CheckoutMercadoPago.vue?vue&type=template&id=ad7bb332"
import script from "./CheckoutMercadoPago.vue?vue&type=script&lang=js"
export * from "./CheckoutMercadoPago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports